import { render, staticRenderFns } from "./PSidebar.vue?vue&type=template&id=28733264&scoped=true&"
import script from "./PSidebar.vue?vue&type=script&lang=ts&"
export * from "./PSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./PSidebar.vue?vue&type=style&index=0&id=28733264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28733264",
  null
  
)

export default component.exports